import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_SEARCH_STRING_FILTER = 'UPDATE_SEARCH_STRING_FILTER' as const;

export const updateSearchStringFilter = (searchString: string) => ({
  data: { searchString },
  type: UPDATE_SEARCH_STRING_FILTER,
});

export type UpdateSearchStringFilterResponseAction = DataAction<
  typeof UPDATE_SEARCH_STRING_FILTER,
  { searchString: string }
>;
